import Cookies from 'js-cookie';
import appConfig from '@/config/app';

const TokenKey = appConfig.cookie.TokenKey;
const setting = appConfig.cookie.setting;

function getToken() {
	return Cookies.get(TokenKey,setting);
}

function setToken(token) {
	return Cookies.set(TokenKey, token, setting);
}

function removeToken() {
	return Cookies.remove(TokenKey,setting);
}


export default {
	getToken,
	setToken,
	removeToken
}




// WEBPACK FOOTER //
// ./src/core/auth.js